<template>
  <div class="col col-md-12">
    <b-tabs>
      <b-tab
        v-for="(tab, index) in tabProps.tabs"
        :key="index"
        :title="(tab.title === 'AlertsResolved' || tab.title === 'FollowUpsResolved') ? 'Resolved' : tab.title"
        :active="!index"
        @click="selectTab(tab.title)"
      >
        <slot :name="tab.slot" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import SlotMixin from '@/mixins/slot';

export default {
  name: 'Tab',
  mixins: [SlotMixin],
  props: {
    tabProps: { type: Object, required: true },
  },
  computed: {
  },
  methods:{
    selectTab(title){
      this.$emit('activeTab' ,title);
    }
  }
};
</script>
<style lang="scss" scoped>
  @import './style.scss';
</style>
